import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, CreateDateColumn, UpdateDateColumn} from 'typeorm';
@Entity('education')
export class Education{

    @PrimaryGeneratedColumn('increment', {name: 'education_id'})
    educationId: number;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'education'
    })
    education: string;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: false,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
}